import { HttpClient, HttpParams } from '@angular/common/http';
// import { Token } from '@angular/compiler/src/ml_parser/lexer';
import { Injectable } from '@angular/core';
import { Observable, of, throwError as observableThrowError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { DeployParams } from 'src/app/deployParams';
import { EventVM } from 'src/app/models/event/event';
import { FcmSubscriptionRequestTO } from 'src/app/models/messaging/fcmSubscriptionRequestTO.interface';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { LoaderService } from '../loader.service';
import { NotificationService } from '../notification.service';
import { UserActivityService } from '../userActivity.service';
import { ModelMapperService } from '../util/model.mapper.service';
import { StorageService } from '../util/storage.service';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class MessagingProviderService extends BaseService {
  private token: string;
  constructor(
    private http: HttpClient,
    protected loaderService: LoaderService,
    protected modelMapperService: ModelMapperService,
    protected userActivityService: UserActivityService,
    protected notificationService: NotificationService,
    protected storage: StorageService) {
    super(loaderService, userActivityService, notificationService, storage);
  }

  public sendEventsForNotification(fcmSubscriptionRequestTO: FcmSubscriptionRequestTO): Observable<any> {
    // dont send notifications for now
    // return of(null);

    const params = new HttpParams();
    const body = JSON.stringify(fcmSubscriptionRequestTO);
    const url = this.notificationClientURL + 'subscriptionReceive';
    console.log(body);
    // return of(null);
    return this.http.post(url, body, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as any),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        console.log(err);
        return [];
      }),
    );
  }

  public getUserEvents(userId: number): Observable<number[]> {
    const params = new HttpParams();
    const body = JSON.stringify(userId);
    const url: string = this.notificationClientURL + 'getUserEvents/' + userId.toString();
    return this.http.get(url, { headers: this.httpHeaders, params }).pipe(
      map((response) => response as number[]),
      publishReplay(1),
      refCount(),
      catchError((err) => {
        console.log(err);
        return [];
      }),
    );
  }
}

